import React from "react";

// Recreated "02 / Portal Badge" nautical wheel — crisp, scalable SVG (no raster).
export const HelmWheel = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg"
       className={className} data-testid="helm-wheel-mark" aria-hidden="true">
    <circle cx="50" cy="50" r="46" stroke="#D4AF37" strokeWidth="2.5" fill="#0B192C" />
    <circle cx="50" cy="50" r="36" stroke="#D4AF37" strokeWidth="1.5" strokeDasharray="2 2" />
    <circle cx="50" cy="50" r="28" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.3" />
    <circle cx="50" cy="50" r="20" stroke="#D4AF37" strokeWidth="2" fill="#0F223D" />
    <g stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round">
      <line x1="50" y1="4" x2="50" y2="96" />
      <line x1="4" y1="50" x2="96" y2="50" />
      <line x1="17.5" y1="17.5" x2="82.5" y2="82.5" />
      <line x1="82.5" y1="17.5" x2="17.5" y2="82.5" />
    </g>
    <circle cx="50" cy="50" r="8" fill="#D4AF37" />
  </svg>
);

// Full badge: wheel + "the HELM" wordmark ("the" smaller than HELM) + Nauticus identifier.
// `variant="light"` for navy backgrounds; `variant="dark"` for light backgrounds.
export const HelmBadge = ({ variant = "light", subtitle = "NAUTICUS · AGENT WORKSPACE", className = "" }) => {
  const helm = variant === "light" ? "text-white" : "text-[#0B192C]";
  const sub = variant === "light" ? "text-slate-300" : "text-slate-500";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="helm-badge">
      <HelmWheel className="w-9 h-9 shrink-0" />
      <div className="leading-none">
        <div className="flex items-baseline gap-1">
          <span className="text-[10px] font-semibold uppercase tracking-widest text-amber-400/90">the</span>
          <span className={`font-display font-bold tracking-wider text-2xl ${helm}`}>HELM</span>
        </div>
        <p className={`text-[9px] font-sans uppercase tracking-widest mt-1 ${sub}`}>{subtitle}</p>
      </div>
    </div>
  );
};

// Compact "03 / Modern" variant for tight spaces (mobile top bar, dense headers).
export const HelmMarkCompact = ({ variant = "light", className = "" }) => {
  const helm = variant === "light" ? "text-white" : "text-[#0B192C]";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="helm-badge-compact">
      <HelmWheel className="w-7 h-7 shrink-0" />
      <span className="flex items-baseline gap-0.5">
        <span className="text-[9px] font-semibold uppercase tracking-widest text-amber-400/90">the</span>
        <span className={`font-display font-bold tracking-wide text-lg ${helm}`}>HELM</span>
      </span>
    </div>
  );
};
